import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pi pi-lock"
}
const _hoisted_3 = {
  key: 1,
  class: "pi pi-unlock"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 flex flex-row flex-wrap"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "flex flex-wrap" }
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = {
  key: 0,
  class: "ml-3 mt-1"
}
const _hoisted_17 = { class: "ml-3 mt-1 text-wrap" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "ml-3 mt-1" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "ml-3 mt-1" }
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.title && _ctx.title.length > 0)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.view == 'toggle' && _ctx.canEdit)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode=!_ctx.editMode))
              }, [
                (!_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                  : _createCommentVNode("", true),
                (_ctx.editMode)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ((_ctx.editMode && _ctx.view=='toggle') || _ctx.view=='cards')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleContacts, (cont) => {
            return (_openBlock(), _createElementBlock("div", {
              key: cont.contactId,
              class: "card mr-3 mb-3",
              style: {"width":"480px"}
            }, [
              _createElementVNode("i", {
                onClick: ($event: any) => (_ctx.removeContact(cont)),
                class: "pi pi-times",
                style: {"cursor":"pointer","float":"right","top":"-10px","position":"relative"}
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("label", null, "First name", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.firstName,
                  "onUpdate:modelValue": ($event: any) => ((cont.firstName) = $event),
                  onChange: _ctx.ensureEmptyContact
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("label", null, "Last name", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.lastName,
                  "onUpdate:modelValue": ($event: any) => ((cont.lastName) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("label", null, "Job title", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.jobTitle,
                  "onUpdate:modelValue": ($event: any) => ((cont.jobTitle) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", null, "Email", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.email,
                  "onUpdate:modelValue": ($event: any) => ((cont.email) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Enable automation emails", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_InputSwitch, {
                  modelValue: cont.enableAutomationEmails,
                  "onUpdate:modelValue": ($event: any) => ((cont.enableAutomationEmails) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "Mobile", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.mobile,
                  "onUpdate:modelValue": ($event: any) => ((cont.mobile) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "DDI", -1)),
                _createVNode(_component_InputText, {
                  modelValue: cont.ddi,
                  "onUpdate:modelValue": ($event: any) => ((cont.ddi) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    ((!_ctx.editMode && _ctx.view=='toggle') || _ctx.view == 'indented-list')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleContacts, (cont) => {
              return (_openBlock(), _createElementBlock("div", {
                key: cont.contactId,
                class: "col-3 item-border-left",
                style: {"min-width":"300px"}
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(cont.firstName) + " " + _toDisplayString(cont.lastName), 1),
                (cont.jobTitle != null && cont.jobTitle.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("i", null, _toDisplayString(cont.jobTitle), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    href: 'mailto:' + cont.email
                  }, _toDisplayString(cont.email), 9, _hoisted_18)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("a", {
                    href: 'tel:' + cont.mobile
                  }, _toDisplayString(cont.mobile), 9, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", {
                    href: 'tel:' + cont.ddi
                  }, _toDisplayString(cont.ddi), 9, _hoisted_22)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}